import React, { useEffect } from 'react';
import { useAnalytics, AnalyticsContextProvider } from '@growth/use-analytics';
import { isOnClient } from '@growth/ssr-utils';
import { _ as _extends, s as sendPdtEvent, i as initOmnitureAnalytics } from '../../dist/omniture-4e08e7dc.esm.js';
import { useApiCall } from '@growth/custom-hooks/useApiCall';
import { getAuthToken } from '@growth/auth-helpers';
import { fetchRequest } from '@growth/fetch-request';
import { G as GoTribeWidgetContent } from '../../dist/GoTribeWidgetContent-199506be.esm.js';
import '@growth/pdt-push';
import '@growth/analytics-plugin-adobe';
import '@growth/web-analytics';
import '@growth/loader/shimmer/horizontal';
import '../../dist/DropDownPortal-a0ddf29b.esm.js';
import 'react-dom';
import '@growth/bottom-sheet';
import '@growth/modal';
import '@growth/config-store/browser';
import '../../dist/taggedTemplateLiteralLoose-7a042257.esm.js';
import 'styled-components';
import '@growth/design-system';

var fetchGotribeWidgetData = function fetchGotribeWidgetData(_ref) {
  var platform = _ref.platform,
    bookingPayload = _ref.bookingPayload;
  var headers = {
    'Auth': getAuthToken(),
    'Authorization': '7NP82fpV0TsA9JrK',
    'currency': 'inr',
    'language': 'en',
    'region': 'IN',
    'org': 'GI',
    'Profile-Type': 'PERSONAL'
  };
  return fetchRequest('https://membership-service.goibibo.com/loyalty/bookingMessage', {
    headers: headers,
    credentials: 'omit',
    body: _extends({
      "platform": platform
    }, bookingPayload)
  }).post();
};

var GoTribeThankyouInner = function GoTribeThankyouInner(_ref) {
  var lob = _ref.lob,
    isMobile = _ref.isMobile,
    bookingPayload = _ref.bookingPayload,
    onLoad = _ref.onLoad,
    wrapperStyle = _ref.wrapperStyle;
  var pageName = lob + "_page";
  var _useAnalytics = useAnalytics(),
    adobe = _useAnalytics.adobe;
  var _useApiCall = useApiCall(fetchGotribeWidgetData),
    goTribeData = _useApiCall[0],
    getGoTribeData = _useApiCall[1];
  var _ref2 = goTribeData || {},
    completed = _ref2.completed,
    data = _ref2.data,
    error = _ref2.error;
  var _ref3 = data || {},
    _ref3$errors = _ref3.errors,
    goTribeInternalError = _ref3$errors === void 0 ? [] : _ref3$errors,
    _ref3$cards = _ref3.cards,
    cards = _ref3$cards === void 0 ? [] : _ref3$cards,
    _ref3$tierNumber = _ref3.tierNumber,
    tierNumber = _ref3$tierNumber === void 0 ? 1 : _ref3$tierNumber;
  useEffect(function () {
    getGoTribeData({
      platform: isMobile ? 'mobile' : 'desktop',
      bookingPayload: bookingPayload
    }); // to check
  }, []);
  var thankyouCardId = 'thankyou_booking_info_card';
  var thankyouCard = cards == null ? void 0 : cards.find(function (item) {
    return item.templateId === thankyouCardId;
  });

  // if redirect url added in api on click it will be redirected there otherwise /loyalty
  var _ref4 = (thankyouCard == null ? void 0 : thankyouCard.data) || {},
    header = _ref4.header,
    subHeader = _ref4.subHeader,
    imageUrl = _ref4.imageUrl,
    benefits = _ref4.benefits,
    style = _ref4.style,
    redirectUrl = _ref4.redirectUrl;
  useEffect(function () {
    adobe.track('ctaClick', {
      cta: {
        name: 'GI_GOTRIBE_LOB_INLINE_TY_PAGE',
        type: "itemLoaded | " + lob + "_TY_Page",
        componentName: 'GI_GOTRIBE_LOB_INLINE_TY_PAGE'
      }
    });
    sendPdtEvent({
      eventName: "gotribe_lob_inline_ty_page_screenLoad",
      contentId: 'GI_GOTRIBE_LOB_INLINE_TY_PAGE',
      contentCategoryName: lob + "_thankyou",
      pageName: pageName
    });
  }, []);
  var handleClick = function handleClick() {
    adobe.track('ctaClick', {
      cta: {
        name: 'GI_GOTRIBE_LOB_INLINE_TY_PAGE',
        type: "ctaClick | " + lob + "_TY_Page",
        componentName: 'GI_GOTRIBE_LOB_INLINE_TY_PAGE'
      }
    });
    sendPdtEvent({
      eventName: 'gotribe_lob_inline_review_ctaClick',
      contentId: thankyouCardId,
      pageName: pageName
    });
    window.location.href = redirectUrl || '/loyalty';
  };
  if (completed && (error || goTribeInternalError.length > 0) || !(thankyouCard != null && thankyouCard.data)) return /*#__PURE__*/React.createElement(React.Fragment, null);
  return /*#__PURE__*/React.createElement(GoTribeWidgetContent, {
    lob: lob,
    loading: !completed,
    tier: tierNumber,
    headerText: header,
    mainDesc: subHeader,
    image: imageUrl,
    benefits: benefits,
    style: style,
    isMobile: isMobile,
    showThankyouPageStyling: !isMobile,
    showCta: false,
    handleClick: handleClick,
    onLoad: onLoad,
    wrapperStyle: wrapperStyle
  });
};

var GoTribeThankyou = function GoTribeThankyou(_ref) {
  var lob = _ref.lob,
    isMobile = _ref.isMobile,
    bookingPayload = _ref.bookingPayload,
    onLoad = _ref.onLoad,
    wrapperStyle = _ref.wrapperStyle;
  var adobe;
  if (isOnClient) {
    adobe = initOmnitureAnalytics({
      lobName: lob,
      debug: false,
      flavour: isMobile ? 'mweb' : 'dweb'
    });
  }
  return /*#__PURE__*/React.createElement(AnalyticsContextProvider, {
    adobeInstance: adobe
  }, /*#__PURE__*/React.createElement(GoTribeThankyouInner, {
    onLoad: onLoad,
    lob: lob,
    isMobile: isMobile,
    bookingPayload: bookingPayload,
    "data-testid": "go-tribe-thankyou-inner",
    wrapperStyle: wrapperStyle
  }));
};

export { GoTribeThankyou };
